import { Component, HostListener, Inject, Injector, ViewChild, AfterViewInit, OnDestroy, ComponentRef, ViewContainerRef, DOCUMENT } from '@angular/core';
import { BootstrapRequestContext } from 'tbs-typings';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router';
import { AuthenticationService } from './core/authentication/authentication.service'
import { JwtHelper } from './core/guards/jwt.helper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HelperService } from './shared/services/helper.service';
import { catchError, filter, map, take, takeUntil } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { GlobalObjectsService } from './shared/services/global-objects.service';
import { UiconfigrationService } from './core/services/uiconfigration.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { UIConfigurationType } from 'src/app/shared/models/uiconfigration.interface';
import { CommonService } from 'src/app/core/services';

import { Constants, SessionStorageKey, TransferAction, WebSiteType } from './shared/models/constants';
import { forkJoin, of, Subject, Subscription } from 'rxjs';
import { TBSBaseComponent } from './shared/models/tbsBaseComponent';
import { onLCP, onINP, onCLS, onTTFB, onFCP } from 'web-vitals/attribution';
import { DelegateForEmployeeType } from './shared/models/actAsDelegateForType.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ExternalRedirectActionPopupComponent } from './shared/external-redirect-action-popup/external-redirect-action-popup.component';
import { AonAiChatPanelComponent } from './modules/ai-chat/aon-ai-chat-panel/aon-ai-chat-panel.component';
import { SelfServiceUserDisclaimerComponent } from './shared/self-service-templates/self-service-user-disclaimer/self-service-user-disclaimer.component';
import { AiChatService } from './modules/ai-chat/ai-chat.service';
import { UserCustomSettings } from './shared/models/userCustomSettings.model';
import { ManagementRightService } from './modules/self-service/management-right.service';
import { TransferStatus } from './shared/models/selfService.model';
import { AnalyticsNavigation } from 'src/app/modules/analytics/analytics.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent extends TBSBaseComponent implements AfterViewInit, OnDestroy {
  baseUrl: string;
  siteName = '';
  FooterStyleSwitch = false;
  closeResult: string;
  siteTheme: string;
  darkModeEnabled: boolean;
  isTempPassword = false;
  IsTermsAccepted = true;
  IsPrivacyPolicyAccepted = true;
  IsMarketingPreferenceCompleted = true;
  IsOtherInfoCollectionCompleted = true;
  isCollectIvrInfoCompleted = true;
  enableFirstTimeUser = false;
  enableUserIvrInfo = false;
  enableTermsAcceptance = false;
  enablePrivacyPolicyAcceptance = false;
  enableMarketingPreference = false;
  enableCollectOtherInfo = false;
  clientBrandingColour: string;
  supportedByExternalService = true;
  defaultPageTitle: string;
  clientBrandingModeActive = false;
  clientBrandingColourRGB: any;
  skinnyFooterActive = false;
  uiConfig: UIConfigurationType;
  isCategorizationEnabled: boolean = false;
  enableHighContrastMode = false;
  isExpressCheckoutEnabled = false;
  siteType: string;
  isInsideAndroidApp: boolean = false;
  private readonly showChatSub: Subscription;
  lastNavigationStart: number = Date.now();
  showDelegateBar: boolean = false;
  delegateEmployees: DelegateForEmployeeType[];
  showDelegateMastHead: boolean = false;
  private navigationStartContext: { navigationId: number; navigationStart: number } | null = null;
  get isSelfServiceSite(): boolean { return this.helperService.isSelfServiceSite; }
  showHeaderAndFooter = true;
  @ViewChild(ExternalRedirectActionPopupComponent) ExternalRedirectActionPopupComponent;
  public chatPanelRef: ComponentRef<AonAiChatPanelComponent> | null = null;

  private readonly queryReset = new Subject<void>();
  isChatPanelOpen: any;
  private hasPolled = false;
  constructor(@Inject('BootstrapRequestContext') private readonly bootstrapRequestContext: BootstrapRequestContext,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly injector: Injector,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly authenticationService: AuthenticationService,
    private readonly modalService: NgbModal,
    private readonly breadcrumbService: BreadcrumbService,//Do not revmove, otherwise there will be breadcrumb refresh issue - Oliver
    private readonly title: Title,
    private readonly ngxService: NgxUiLoaderService,
    public helperService: HelperService,
    private readonly uiconfigrationService: UiconfigrationService,
    private readonly globalObjectsService: GlobalObjectsService,
    protected commonService: CommonService,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly aiChatService: AiChatService,
    private readonly managementService: ManagementRightService
  ) {
    super(injector);
    this.aiChatService.openChat$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(shouldOpen => shouldOpen ? this.openChatPanel() : this.closeChatPanel());
    this.addResourceStringKeys([
      'Aon.Nice.ChatUnavailable'
    ]);

    if (this.helperService.isInternalEditorSite) {
      this.addResourceStringKeys([
        'Aon.SelfService.OptionNotAvailable',
        'Aon.SelfService.ManagementRightsHoverText',
        'Aon.SelfService.ManagementRightsStatusMessage',
      ])
    }
    if (sessionStorage.getItem(SessionStorageKey.isInsideAndroidApp) == 'true') {
      this.isInsideAndroidApp = true;
    }

    if ((sessionStorage.getItem(SessionStorageKey.IsFromMobileApp) === 'true' && this.helperService?.isPureContentPageForMobile) || this.helperService?.isAllowAnonymousAccessPureContentPageForMobile) {
      // Added the loader here. Because there's some empty page displaying in mobile before that child component load
      this.ngxService.start("MOBILE_CONTENT_INIT");
      this.showHeaderAndFooter = false;
    }
    let root = document.documentElement;
    this.setBrandStyle(root);
    this.helperService.getAonSettings().subscribe((res) => {
      this.isExpressCheckoutEnabled = res.enableExpressCheckout;
    })
    this.baseUrl = this.helperService.getBaseUrl();
    let curLanguageCode = JSON.parse(localStorage.getItem('SelectedLanguage'));
    let currentCulture = curLanguageCode.cultureCode;
    if (this.document.documentElement.lang.toLowerCase() != currentCulture.toLowerCase()) {
      this.document.documentElement.lang = currentCulture;
    }
    const culturePrefix = currentCulture.split('-')[0].toLowerCase();
    this.document.documentElement.dir = Constants.RtlCulturePrefixes.includes(culturePrefix) ? 'rtl' : 'ltr';
    this.loadResourceStringAsObservable()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => this.getResouceStringsAsObject(res));
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event: NavigationEnd) => {
        let child = this.activatedRoute.firstChild;
        if (!child) {
          return { 'title': this.activatedRoute.snapshot.data.title || this.defaultPageTitle, 'event': event };
        }
        while (child.firstChild) {
          child = child.firstChild;
        }
        return { 'title': child.snapshot.data.title || this.defaultPageTitle, 'event': event };
      })
    ).subscribe(data => {
      this.recordNavigation(data);
      this.title.setTitle(data.title);
      if (this.notFirstDestinationPath(data)) {
        if (this.helperService.isInternalEditorSite && this.managementService.isPollCheckActive === false && !this.hasPolled) {
          this.hasPolled = true;
          forkJoin(this.managementService.pollTransferStatus(TransferAction.Export), this.managementService.pollTransferStatus(TransferAction.Import))
            .pipe(
              catchError(error => {
                return of([{ isThreadActive: false, threadStages: [] }, { isThreadActive: false, threadStages: [] }]);
              }),
              takeUntil(this.unsubscribe) // Added to prevent memory leaks
            ).subscribe(([exportStatus, importStatus]: [TransferStatus, TransferStatus]) => {
              if (exportStatus.isThreadActive) {
                this.managementService.isPollCheckActive = true;
                this.managementService.activeAction = TransferAction.Export;
                this.managementService.startPolling([]);
              }
              else if (importStatus.isThreadActive) {
                this.managementService.isPollCheckActive = true;
                this.managementService.activeAction = TransferAction.Import;
                this.managementService.startPolling([]);
              } else {
                this.managementService.isPollCheckActive = false;
                this.managementService.activeAction = null;
              }
            });
        }
        this.firstDestinationPageValidate(data);
      }
    });
    this.setupDelegate();

    this.globalObjectsService.delegateEmployeeSelfSelected
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(dess => {
        if (dess != null) {
          this.showDelegateMastHead = !dess;
        }
      })


    this.helperService.externalLinkURL.subscribe((externalLinkURL) => {
      this.ExternalRedirectActionPopupComponent.openmodal(externalLinkURL);
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.analyticsService.beginNavigation(event.id);
        if (event.url != this.router.url) {
          this.initializeNavigation(event);
        }

        const manualLogout = sessionStorage.getItem('manualLogout') === 'true';

        this.helperService.trackTheReferrerPath(this.router.url, event.url);
        if (this.helperService.IsVanityURLForMultiTenantEnabled()) {
          if (event.url != this.router.url && this.authenticationService.isLogin) {
            let jwtHelper = new JwtHelper();
            let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
            if (currentUser?.id_token) {
              let idToken = jwtHelper.decodeToken(currentUser.id_token);
              if (idToken.ClientCode && event.url.toLowerCase().indexOf(idToken.ClientCode.toLowerCase()) < 0) {
                this.authenticationService.logout().subscribe(() => {
                  if (!this.helperService.AllowAnonymousAccess()) {
                    this.helperService.narBarCollapseState.next(true);
                    const isFromMobileApp = sessionStorage.getItem(SessionStorageKey.IsFromMobileApp) === 'true';
                    if (isFromMobileApp) {
                      this.router.navigate([this.baseUrl + '/login'], { queryParams: { timestamp: Date.now(), manualLogout: manualLogout } });
                    } else {
                      this.router.navigate([this.baseUrl + '/login']);
                    }
                    this.globalObjectsService.logoutProfile = true;
                    this.commonService.logoutInProgress = false;
                  }
                  else {
                    this.router.navigate([this.baseUrl + '/']);
                    this.globalObjectsService.logoutProfile = true;
                    this.globalObjectsService.showClientLogo.next(false);
                  }
                });
              }
            }
          }
        }
      }
      if (event instanceof NavigationEnd) {
        this.globalObjectsService.stopBenefitSaveAlertTrigger = false;
        this.FooterStyleSwitch = false;
        this.helperService.removeTheReferrerPath(event.url);
        const requiredMatches = [
          '/login',
          '/account/forgotpassword',
          '/account/forgotusername',
          '/account/registration',
          '/account/firsttimeuser',
          '/account/contactpreferences',
          '/account/otherinfo',
          '/account/setnewpassword',
          '/account/collectivrinfo',
          '/account/unauthorised',
          '/pre-auth-landing'
        ]

        if (this.helperService.siteType == "OLB" && this.darkModeEnabled || this.helperService.siteType != "OLB" || this.helperService.siteType == "OLB" && !this.darkModeEnabled && this.enableHighContrastMode) {
           if (this.helperService.isPemSite) {
            this.FooterStyleSwitch = true;
          } else {
            for (let item of requiredMatches) {
              if (event.url.indexOf(item) != -1) {
                this.FooterStyleSwitch = true;
              }
            }
          }
        }
        const mainHeader = document.getElementById('main-app-content');
        if (mainHeader) {
          mainHeader.focus();
        }

        /**
         * Check and Remove the Cached Benefit Reveiw Data
         */
        this.commonService.checkAndRemoveTheCachedBenefitReviewData();
        // Remove Client Content Cache
        this.checkAndRemoveTheClientContentCache();
        sessionStorage.removeItem('manualLogout');
      }
      // set main content min height on route change
      this.helperService.setMainContentMinHeight();
    });

    this.globalObjectsService.resetClientBrandStyle.subscribe(rc => {
      if (rc === true) {
        this.setBrandStyle(root);
        this.globalObjectsService.resetClientBrandStyle.next(false);
      }
    });
    this.siteName = this.bootstrapRequestContext.siteName;

    // It checks categorization enabled or not
    this.globalObjectsService.CategorizationEnabled
      .subscribe((isCategorizationEnabled) => {
        this.isCategorizationEnabled = isCategorizationEnabled;
      });
    this.siteType = this.helperService.siteType;

    this.sendToAnalytics = (metric) => { this.analyticsService.trackWebVital(metric); };
    onTTFB(this.sendToAnalytics, { reportSoftNavs: true });
    onCLS(this.sendToAnalytics, { reportSoftNavs: true });
    onLCP(this.sendToAnalytics, { reportSoftNavs: true });
    onINP(this.sendToAnalytics, { reportSoftNavs: true });
    onFCP(this.sendToAnalytics, { reportSoftNavs: true });

    const navigation = performance.getEntriesByType('navigation')[0];
    if (navigation) {
      let loadTime = navigation.loadEventEnd;
      let appLoadTime = Date.now() - performance.timeOrigin;
      const ssoTime = this.helperService.getUrlParameter("time");
      if (ssoTime) {
        //Include SSO processing time if login from SSO
        loadTime = loadTime + Number(ssoTime);
        appLoadTime = appLoadTime + Number(ssoTime);
      }
      let pageDetails = {
        'event': 'app-loaded',
        'app-load-timestamp': Date.now(),
        'app-loading-time': loadTime,
        'pre-navigation-time': appLoadTime,
        'content-loading-time': appLoadTime,
        'pageViewLogged': true
      };
      this.analyticsService.recordPageView(pageDetails);
    }
  }

  private checkAndRemoveTheClientContentCache(): void {
    try {
      let sessionData = sessionStorage.getItem(SessionStorageKey.ClientContentPageCallToActions);
      //if (sessionData && this.router.url != "/client-content-page") {
      // included scenario where url appended with culture code
      if (sessionData && this.router.url.indexOf("/client-content-page") == -1) {
        sessionStorage.removeItem(SessionStorageKey.ClientContentPageCallToActions);
      }
    } catch { }
  }

  private setBrandStyle(root: HTMLElement) {
    let uiConfigType = this.uiconfigrationService.getUIConfiguration();
    this.uiConfig = this.uiconfigrationService.getUIConfiguration();
    this.skinnyFooterActive = this.uiConfig.uiConfiguration?.showSkinnyFooter;
    this.enableHighContrastMode = this.uiConfig.uiConfiguration?.enableHighContrastMode;
    this.clientBrandingColour = uiConfigType?.uiConfiguration?.clientPrimaryBrandColour;
    this.clientBrandingColourRGB = this.hexToRgb(this.clientBrandingColour);
    this.siteTheme = uiConfigType?.uiConfiguration?.presetTheme;
    this.darkModeEnabled = uiConfigType?.uiConfiguration?.enableDarkMode;
    let reg = /^#([0-9a-f]{3}){1,2}$/i;
    if (reg.test(this.clientBrandingColour)) {
      this.clientBrandingModeActive = true;
      root.style.setProperty('--client-branding-hexcode', this.clientBrandingColour);
      root.style.setProperty('--client-branding-rgb', this.clientBrandingColourRGB);
    } else {
      this.clientBrandingModeActive = false;
    }
  }

  private hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? parseInt(result[1], 16) + "," + parseInt(result[2], 16) + "," + parseInt(result[3], 16) : null;
  }


  private firstDestinationPageValidate(data: { title: any; event: NavigationEnd; }) {
    this.baseUrl = this.helperService.getBaseUrl();
    if (sessionStorage.getItem("Id_CustomSettings") != null && this.authenticationService.isLogin) {
      let idCustomSettings: UserCustomSettings = JSON.parse(sessionStorage.getItem("Id_CustomSettings"));
      this.setFirstUserJourneyFlags(idCustomSettings);
      this.ensureFirstDestinationPage(data.event);
    } else {
      this.authenticationService.currentUser.subscribe(user => {
        let jwtHelper = new JwtHelper();
        if (user?.id_token) {
          let parsedToken = jwtHelper.decodeToken(user.id_token);
          let customSettings: UserCustomSettings = (parsedToken.UserCustomSettings != null) ? JSON.parse(parsedToken.UserCustomSettings) : null;
          this.setFirstUserJourneyFlags(customSettings);
          this.ensureFirstDestinationPage(data.event);
        }
      });
    }
  }

  private notFirstDestinationPath(data: { title: any; event: NavigationEnd; }) {
    return !data.event.url.includes('/account/contactpreferences') && (!data.title?.includes('First Time User')) && (!data.title?.includes('Login')) && (!data.event.url.includes('/account/otherinfo')) && (!data.event.url.includes('/help')) && (!data.event.url.includes('/account/collectivrinfo'));
  }

  private setFirstUserJourneyFlags(idCustomSettings: UserCustomSettings) {
    if (this.helperService.isEditorSite) {
      this.IsTermsAccepted = idCustomSettings.IsTermsAccepted;
      return;
    }
    const uiConfig = this.authenticationService.getUIConfig()?.uiConfiguration;
    if (uiConfig != null) {
      this.enableTermsAcceptance = uiConfig.enableTermsAcceptance;
      this.enablePrivacyPolicyAcceptance = uiConfig.enablePrivacyPolicyAcceptance;
      this.enableMarketingPreference = uiConfig.enableMarketingConsent && !uiConfig.disableMarketingConsentDuringLogin;
      this.enableCollectOtherInfo = uiConfig.userOtherInfoFormID && uiConfig.enableCollectOtherInfo;
      this.enableFirstTimeUser = uiConfig.enableFirstTimeUser;
      this.enableUserIvrInfo = uiConfig.enableCollectIvrInfo;
    }
    if (idCustomSettings != null) {
      this.isTempPassword = idCustomSettings.IsTemporaryPassword;
      this.IsOtherInfoCollectionCompleted = idCustomSettings.IsOtherInfoCollectionCompleted;
      this.IsTermsAccepted = idCustomSettings.IsTermsAccepted;
      this.IsPrivacyPolicyAccepted = idCustomSettings.IsPrivacyPolicyAccepted;
      this.IsMarketingPreferenceCompleted = idCustomSettings.MarketingPreferenceCompleted;
      this.supportedByExternalService = true;
      this.isCollectIvrInfoCompleted = idCustomSettings.IsCollectIvrInfoCompleted;
      if (sessionStorage.getItem("SupportedByExternalService")) {
        this.supportedByExternalService = JSON.parse(sessionStorage.getItem("SupportedByExternalService"));
      }
    }
    // Update delegate bar visibility after flags are set
    this.updateDelegateBarVisibility();
  }

  private ensureFirstDestinationPage(event: NavigationEnd): void {
    if (this.helperService.isEditorSite) {
      return this.handleEditorSiteNavigation();
    }

    const isExpressLoginInFlow = JSON.parse(sessionStorage.getItem(SessionStorageKey.IsExpressLoginInFlow));
    if (this.authenticationService.isLogin && (!this.isExpressCheckoutEnabled || !isExpressLoginInFlow)) {
      if (this.enableFirstTimeUser && this.isTempPassword && !this.authenticationService.isSso) {
        this.authenticationService.hasHighPriorityPage.next(true);
        this.router.navigate([this.baseUrl + '/account/firsttimeuser']);
      }
      else if ((!this.IsTermsAccepted && this.enableTermsAcceptance)
        || (!this.IsPrivacyPolicyAccepted && this.enablePrivacyPolicyAcceptance)
        || (!this.IsMarketingPreferenceCompleted && (this.enableMarketingPreference && this.supportedByExternalService))) {
        this.authenticationService.hasHighPriorityPage.next(true);
        this.router.navigate([this.baseUrl + '/account/contactpreferences']);
      }
      else if (!this.IsOtherInfoCollectionCompleted && this.enableCollectOtherInfo) {
        this.authenticationService.hasHighPriorityPage.next(true);
        this.router.navigate([this.baseUrl + '/account/otherinfo']);
      } else if (!this.isCollectIvrInfoCompleted && this.enableUserIvrInfo && !this.authenticationService.isImpersonatingUser) {
        this.authenticationService.hasHighPriorityPage.next(true);
        this.router.navigate([this.baseUrl + '/account/collectivrinfo']);
      }

    }
  }

  private handleEditorSiteNavigation(): void {
    if (!this.IsTermsAccepted) {
      this.authenticationService.hasHighPriorityPage.next(true);
      this.router.navigate([this.baseUrl + '/account/contactpreferences']);
      return;
    }
    if (this.helperService.isExternalEditorSite && this.authenticationService.isLogin) {
      this.showDisclaimerModal();
    }
  }

  private initializeNavigation(event: NavigationStart): void {

    this.navigationStartContext = {
      navigationId: event.id,
      navigationStart: Date.now()
    };
  }

  private showDisclaimerModal(): void {
    const customSettings: UserCustomSettings = JSON.parse(sessionStorage.getItem('Id_CustomSettings'));
    if (customSettings && !customSettings.IsDisclaimerViewed && !this.modalService.hasOpenModals()) {
      this.modalService.open(SelfServiceUserDisclaimerComponent, { size: 'lg', backdrop: 'static', centered: true, keyboard: false, container: "#app-modal-anchor", ariaLabelledBy: 'user-disclaimer-modal-title' });
    }
  }

  private recordNavigation(navigationData:any): void {
    let navigationEventCode = 'router-navigtion';
    if (navigationData.event.url.startsWith('/product')) {
      navigationEventCode = 'product-navigtion';
    }

    const navigationEvent: AnalyticsNavigation = {
      event: navigationEventCode,
      navigationId: navigationData.event.id,
      routertitle: navigationData.title,
      routerurl: navigationData.event.urlAfterRedirects,
      routeOwnerKey: this.analyticsService.normalizeRouteOwnerKey(navigationData.event.urlAfterRedirects),
      navigationStart: this.navigationStartContext?.navigationId == navigationData.event.id ? this.navigationStartContext.navigationStart : Date.now(),
      pageViewLogged: false,
      queryString: window.location.search
    };

    this.analyticsService.setCurrentNavigation({ ...navigationEvent });
    this.analyticsService.recordEvent(navigationEvent);
    this.navigationStartContext = null;
  }

  private setupDelegate() {
    this.authenticationService.currentUser.subscribe(user => {
      let jwtHelper = new JwtHelper();
      if (user?.id_token) {
        let parsedToken = jwtHelper.decodeToken(user.id_token);
        let delegateEmployeeSettings = parsedToken.DelegateEmployeeSettings != null ? JSON.parse(parsedToken.DelegateEmployeeSettings) : null;
        if (delegateEmployeeSettings) {
          delegateEmployeeSettings = this.helperService.toCamel(delegateEmployeeSettings);
          this.delegateEmployees = delegateEmployeeSettings.delegateForEmployees;
          this.updateDelegateBarVisibility();
        } else {
          this.showDelegateBar = false;
        }
      }
    });
  }

  private updateDelegateBarVisibility() {
    if (this.delegateEmployees && this.delegateEmployees.length > 0) {
        const shouldHideDelegateBar = !this.isCollectIvrInfoCompleted && this.enableUserIvrInfo && !this.authenticationService.isImpersonatingUser;
        this.showDelegateBar = !shouldHideDelegateBar;
    } else {
        this.showDelegateBar = false;
    }
  }

  showLightFooter(): boolean {
    //When showLightFooter enabled, if user is on quote pages/benefit pages then we will show app-footer-light.
    //When showLightFooter enabled, if user not on quote pages/benefit pages then we will show app-footer.
    //When showLightFooter not enabled, irrespective of user flow we will show app-footer.
    if (this.uiConfig.uiConfiguration?.showLightFooter) {
      return this.helperService.isQuoteRoute() || this.helperService.isBenefitRoute();
    }
  }

  @HostListener('keydown.shift.tab', ['$event'])
  @HostListener('keydown.tab', ['$event'])
  listenKeyDownTabEvent(event: any): void {
    if (this.modalService.hasOpenModals()) {
      const getTheTargetElement = () => {
        let targettedElement = document.querySelector("ngb-modal-window");
        try {
          let listOfModalWindow = document.querySelectorAll("ngb-modal-window");
          if (listOfModalWindow.length > 1) {
            // setting the last modal window if it's having more than 1
            targettedElement = listOfModalWindow[listOfModalWindow.length - 1];
          }
        } catch { }
        return targettedElement;
      }
      this.helperService.trapTheFocusWithinTheTargetedElement(getTheTargetElement(), event);
    }
  }

  showNicChat(): boolean {
    if (this.bootstrapRequestContext.webSiteType != WebSiteType.MemberSite) {
      return false;
    }
    if (!this.bootstrapRequestContext.enableWebChat && !this.bootstrapRequestContext.enableCxoneNiceWebChat) {
      return false;
    }
    if (this.helperService.AllowAnonymousAccess()) {
      return true;
    }
    if (this.helperService.isLoggedOn()) {
      return true;
    }
    return false;
  }

  sendToAnalytics(metric) { };

  elementClicked(evt) {
    if (this.uiConfig.uiConfiguration?.showExternalLinkPopup) {
      const href = evt.target.getAttribute('href');
      if (href && this.helperService.hasHTTPProtocol(href)) {
        evt.preventDefault();
        this.ExternalRedirectActionPopupComponent.openmodal(href);
      }
    }
    const analyticsParameter = evt.target.getAttribute('heap-track-click');
    if (analyticsParameter) {
      let analyticsCategory = evt.target.getAttribute('heap-track-category');
      if (!analyticsCategory) {
        analyticsCategory = 'General';
      }
      this.analyticsService.trackHeapEvent(analyticsCategory, analyticsParameter, evt.target.textContent);
    }
  }

  ngOnDestroy(): void {
    this.showChatSub.unsubscribe();
    window.removeEventListener('resize', () => this.helperService.setMainContentMinHeight());
    this.queryReset.next();
    this.queryReset.complete();
    this.removeComponent();

  }

  ngAfterViewInit() {
    window.addEventListener('resize', () => this.helperService.setMainContentMinHeight());
    this.authenticationService.startPeriodicApiCall();
  }

  toggleChatPanel(): void {
    this.isChatPanelOpen ? this.closeChatPanel() : this.openChatPanel();
  }

  openChatPanel(): void {
    if (!this.chatPanelRef) {
      // Cancel any existing query subscription to prevent duplicate handling
      this.queryReset.next();

      // Scroll to top of the page
      window.scrollTo(0, 0);
      const targetDiv = document.querySelector('#nav');
      // Disable background scrolling
      document.body.style.overflow = 'hidden';
      // Mobile Safari fix to prevent background scrolling
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';

      this.chatPanelRef = this.viewContainerRef.createComponent(AonAiChatPanelComponent);

      targetDiv.appendChild(this.chatPanelRef.location.nativeElement);

      // Element is now attached to the DOM — drive the chat panel's
      // post-attach setup (focus the input, scroll any restored history into
      // view). Doing this from here rather than inside the panel's ngOnInit
      // avoids the need for a defensive setTimeout to defer past appendChild.
      this.chatPanelRef.instance.focusInput();
      this.chatPanelRef.instance.scrollWithAnimation();

      document.body.classList.add('chat-panel-open');
      this.chatPanelRef.instance.closed.subscribe(() => {
        this.isChatPanelOpen = false;
        // Cancel query subscription when panel closes
        this.queryReset.next();
        // Re-enable scrolling when chat panel closes
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        this.chatPanelRef?.destroy();
        this.chatPanelRef = null;
      });

      // Subscribe to query$ to get the latest query and pass it to the panel
      this.aiChatService.query$
        .pipe(
          take(1),
          takeUntil(this.unsubscribe),
          takeUntil(this.queryReset)
        )
        .subscribe(query => this.chatPanelRef?.instance?.setInitialQuery(query));

      this.isChatPanelOpen = true;
    }
  }

  closeChatPanel(): void {
    if (this.chatPanelRef) {
      // Cancel query subscription when manually closing panel
      this.queryReset?.next();
      this.chatPanelRef.instance.close();
      this.removeComponent();
    }
  }

  removeComponent(): void {
    if (this.chatPanelRef) {
      // Remove from DOM
      const element = this.chatPanelRef?.location?.nativeElement;
      if (element?.parentNode) {
        element?.parentNode?.removeChild(element);
      }
      // Destroy the component
      this.chatPanelRef?.destroy();
      this.chatPanelRef = null;
      if (document.body.classList?.contains('chat-panel-open')) {
        document.body.classList.remove('chat-panel-open');
      }

      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';

      this.queryReset?.next();
      this.queryReset?.complete();
    }
  }
}
